import { useMutation } from "react-query";
import { assignUserRolesAndTeams } from "../../../admin/user-roles/lib/roleData";

export const useUsers = () => {
    return useMutation(({ userId, roleIds, groupAssignmentKeys, userStatus }) =>
        assignUserRolesAndTeams(userId, { roleIds, groupAssignmentKeys, userStatus })
    );
};
